module.exports = __webpack_public_path__ + "media/registration/registration-background-f96a25a6.jpg";